import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import Modal from "../Structure/Modal";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import QR_cash from "assets/QR_cash.jpg";
import cash from "assets/cash.svg";
const CashModal = ({
  state,
  toggle,
  text = "message",
  username = "selena",
  setStep,
  name,
}) => {
  const handleClose = (e) => {
    toggle(e);
  };

  return (
    <Modal state={state} close={toggle}>
      <div
        className=" hidden md:block custom-scrollbar w-[95vw]    overflow-y-auto bg-white  xl:w-[60vw]"
        style={{ maxHeight: "90vh" }}>
        <div className="h-gradient  relative h-40 w-full  ">
          <div className="relative left-1/2 top-full flex -translate-x-1/2 -translate-y-1/2 items-center justify-center gap-4">
            <img src={QR_cash} alt="QR_cash" className="" />
          </div>
          <button
            name={name}
            onClick={(e) => toggle(e)}
            className="absolute top-8 right-8 text-white">
            <HighlightOffIcon sx={{ fontSize: "2rem" }} />
          </button>
        </div>
        <div className="flex flex-col items-center gap-4 px-3 pb-4 pt-36 text-center  md:gap-4 md:pb-8 text-neutral-1">
          <div className="flex items-center gap-1">
            <img src={cash} alt="" />
            <span className="text-neutral-1">Cash App</span>
          </div>

          <h2 className="text-3xl font-semibold">Scan QR Code</h2>
          <p className="text-neutral-5">
            We will confirm your payment and email you a receipt.{" "}
          </p>
        </div>
        <div className="flex  justify-center px-3 pb-8 ">
          <button
            name={name}
            onClick={(e) => handleClose(e)}
            className="btn btn-main  ">
            Close
          </button>
        </div>
      </div>
      <div className="flex flex-col gap-4 md:hidden bg-white w-[min(90vw,500px)] py-10 px-8 items-center justify-center">
        <div className="flex items-center gap-2">
          <img src={cash} alt="Cash App" />
          <span className="text-neutral-1 font-bold">Cash App</span>
        </div>
        <div>
          <button className="bg-neutral-1 py-4 px-8 btn-pill text-white flex items-center gap-2">
            <img src={cash} alt="" />
            Continue to Cash App Pay
          </button>
        </div>
        <p className="text-neutral-5 text-center">
          We will confirm your payment and email you a receipt.{" "}
        </p>
        <div className="flex  justify-center px-3 mt-2 ">
          <button
            name={name}
            onClick={(e) => handleClose(e)}
            className="btn btn-main ">
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CashModal;
